import React, { useRef, useState } from "react";
import collaborationStyle from "./collaboration-modal-new.module.css";
import style from "./new-collaboration-modal.module.css";
import CollaborationHeaderNew from "./collaboration-header-new";

export default function CreateCollaborationModal({
  type,
  subtitle,
  inputPlaceholder,
  onDismiss,
  onCreateTeam,
  onCreateProject,
}: {
  type: any;
  subtitle: string;
  inputPlaceholder: string;
  onDismiss: () => void;
  onCreateTeam?: (name: string) => void;
  onCreateProject?: (name: string) => void;
}) {
  const [name, setName] = useState<string>("");

  const modalRef = useRef(null);

  return (
    <div className={collaborationStyle.container} ref={modalRef}>
      <CollaborationHeaderNew title={`Create new ${type}`} subtitle={subtitle} onDismiss={onDismiss} />
      <div className={style.inviteField}>
        <form
          className={collaborationStyle.nameInput}
          onSubmit={(e) => {
            e.preventDefault();
            onCreateTeam && onCreateTeam(name);
            onCreateProject && onCreateProject(name);
          }}
        >
          <input
            onChange={(e) => setName(e.target.value)}
            value={name}
            placeholder={inputPlaceholder}
            autoFocus={true}
            autoComplete="off"
          />
        </form>
        <button
          className={style.createCollaborationButton}
          disabled={name.length === 0}
          onClick={() => {
            onCreateTeam && onCreateTeam(name);
            onCreateProject && onCreateProject(name);
          }}
        >{`Create ${type}`}</button>
      </div>
    </div>
  );
}
